export function getInitialLanguage() {
    try {
        const savedLang = localStorage.getItem("lang");
        if (savedLang) {
            return savedLang.toLowerCase();
        }
    } catch (err) {
        console.warn("Failed to load initial language:", err);
    }

    return "es";
}